import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@prcins/environments';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CancellationProviderService {
  apiUrl = environment.BASE_URL + '/v2/';

  constructor(private http: HttpClient) {}

  /**
   * Creates a cancellation endorsement and returns the guid
   */
  createCancellationEndorsement(type: string = 'PC'): Observable<any> {
    const policyNum = sessionStorage.getItem('currentPolicy');
    return this.http.post(this.apiUrl + 'core/' + policyNum + '/endorsements/cancellation', {});
  }

  /**
   * Checks if a cancellation request already exists for the policy
   */
  checkCancellationRequestExists(policyNum: string): Observable<any> {
    return this.http.get(environment.BASE_URL + '/policy/cancellation/exists/' + policyNum);
  }

  checkCancellationEligibility(policyNum: string): Observable<any> {
    return this.http.get(environment.BASE_URL  + '/policy/cancellation/' + policyNum);
  }

  submitCancellationRequest(policyNumber: string, guid: string, request: any): Observable<any> {
    const url = environment.BASE_URL + '/policy/cancellation/'+ policyNumber + '/endorsements/' + guid;
    return this.http.post(url, request);
  }

  /**
   * Validates uploaded cancellation documents
   */
  validateCancellationDocuments(formData: FormData, policyNum: string, guid?: string): Observable<any> {
    const url = guid 
      ? environment.BASE_URL + '/policy/cancellation/' + policyNum + '/validateDocuments/'+ guid
      : environment.BASE_URL + '/policy/cancellation/' + policyNum + '/validateDocuments';
    return this.http.post(url, formData);
  }
}
